export enum Modal {
  COOKIE_INFO = 'COOKIE_INFO',
  PRINT_CONTRACT = 'PRINT_CONTRACT',
  ERROR_HANDLER = 'ERROR_HANDLER',
}

export enum WebpayPaymentStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  CARD_INVALID_DATA = 'CARD_INVALID_DATA',
  REFUNDED = 'REFUNDED',
}

export enum WebpayPaymentPostStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  ISSUED = 'ISSUED',
  NOT_ISSUED = 'NOT_ISSUED',
  FAILURE = 'FAILURE',
  CARD_INVALID_DATA = 'CARD_INVALID_DATA',
}

export enum WebpayBranch {
  FIRE_ALON = 'FIRE_ALON',
  FIRE_ANELIXIS = 'FIRE_ANELIXIS',
  FIRE = 'FIRE',
  INTERNATIONAL_LIFE = 'INTERNATIONAL_LIFE',
  CAR = 'CAR',
  MOTOR = 'MOTOR',
  MOTOR_PIA = 'MOTOR_PIA', //REMOVED IN RELEASE
  LIFE_HEALTH = 'LIFE_HEALTH',
  PERSONAL_ACCIDENT = 'PERSONAL_ACCIDENT',
  SHIP = 'SHIP',
  TRANSPORT = 'TRANSPORT',
  CIVIL_LIABILITY = 'CIVIL_LIABILITY',
  LIABILITY = 'LIABILITY',
  ENGINEERING_FAULT = 'ENGINEERING_FAULT',
  ANY_DANGER = 'ANY_DANGER',
  THEFT_TRUST = 'THEFT_TRUST',
  SHIP_CREW = 'SHIP_CREW',
}

export enum SceneKey {
  HOME_PROPERTY = 'HOME_PROPERTY',
  HEALTH = 'HEALTH',
  AYTO = 'AYTO',
  LIFE_HEALTH = 'LIFE_HEALTH',
  BUSINESS = 'BUSINESS',
  OTHER_INSURANCES = 'OTHER_INSURANCES',
  CIVIL_LIABILITY = 'CIVIL_LIABILITY',
}

export const BRANCH_TO_SCENE_KEY: Partial<Record<WebpayBranch, SceneKey>> = {
  [WebpayBranch.FIRE_ALON]: SceneKey.HOME_PROPERTY,
  [WebpayBranch.FIRE_ANELIXIS]: SceneKey.HOME_PROPERTY,
  [WebpayBranch.FIRE]: SceneKey.HOME_PROPERTY,
  [WebpayBranch.INTERNATIONAL_LIFE]: SceneKey.HEALTH,
  [WebpayBranch.CAR]: SceneKey.AYTO,
  [WebpayBranch.MOTOR]: SceneKey.AYTO,
  [WebpayBranch.MOTOR_PIA]: SceneKey.AYTO,
  [WebpayBranch.LIFE_HEALTH]: SceneKey.LIFE_HEALTH,
  [WebpayBranch.PERSONAL_ACCIDENT]: SceneKey.BUSINESS,
  [WebpayBranch.SHIP]: SceneKey.OTHER_INSURANCES,
  [WebpayBranch.TRANSPORT]: SceneKey.OTHER_INSURANCES,
  [WebpayBranch.CIVIL_LIABILITY]: SceneKey.CIVIL_LIABILITY,
  [WebpayBranch.LIABILITY]: SceneKey.CIVIL_LIABILITY,
  [WebpayBranch.ENGINEERING_FAULT]: SceneKey.OTHER_INSURANCES,
  [WebpayBranch.ANY_DANGER]: SceneKey.OTHER_INSURANCES,
  [WebpayBranch.THEFT_TRUST]: SceneKey.OTHER_INSURANCES,
  [WebpayBranch.SHIP_CREW]: SceneKey.OTHER_INSURANCES,
};

export enum WebpayPaymentMethod {
  IRIS = 'IRIS',
  EPAY = 'EPAY',
}

export enum GoogleAnalytics {
  SEARCH_CRITERIA = 'SEARCH_CRITERIA',
  PAYMENT_OPTIONS = 'PAYMENT_OPTIONS',
  PAYMENT = 'PAYMENT',
  PAYMENT_IN_PROGRESS = 'PAYMENT_IN_PROGRESS',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  COMPLETE = 'COMPLETE',
  SEND_EMAIL = 'SEND_EMAIL',
  SAVE_PDF = 'SAVE_PDF',
}

export enum ContractInfoEventState {
  INITIAL = 'INITIAL',
  FETCHED = 'FETCHED',
}

export enum StepperEventState {
  INITIAL = 'INITIAL',
  COMPLETE = 'COMPLETE',
}

export enum SpinnerEventState {
  INITIAL = 'INITIAL',
  LOADED = 'LOAD',
}

export enum Languages {
  GREEK = 'el',
  ENGLISH = 'en',
}

export enum MatProgressSpinner {
  DETERMINATE = 'determinate',
  INDETERMINATE = 'indeterminate',
}

export enum MatSpinnerStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  IN_PROGRESS = 'inProgress',
  TOKEN_EXPIRED = 'sessionExpired',
  IN_REDIRECT = 'inRedirect',
}

export enum MatSpinnerAction {
  PAYMENT = 'Payment',
  SEND_EMAIL = 'SendEmail',
  SAVE_PDF = 'SavePdf',
}

export enum MatSpinnerStatusContent {
  SUCCESS_CONTENT = 'successContent',
  WARNING_CONTENT = 'warningContent',
  IN_PROGRESS_CONTENT = 'inProgressContent',
}

export enum SendEmailStatus {
  OK = 'OK',
  FAILURE = 'FAILURE',
}

export enum LocalStorageKeys {
  LANGUAGE = 'webpay-language',
  KIP = 'webpay-kip',
  INSTALLMENTS = 'webpay-installments',
  SIGNATURE = 'webpay-signature',
  URL = 'webpay-url',
  MY_ETHNIKI_URL = 'my_ethniki_url',
}
